import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteArticleListComponent } from './website-article-list.component'
import { SharedModule } from '../shared/shared.module'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'



@NgModule({
  declarations: [WebsiteArticleListComponent],
  imports: [
    CommonModule,
    SharedModule,
    InfiniteScrollModule
  ],
  exports: [WebsiteArticleListComponent]
})
export class WebsiteArticleListModule { }
